var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceDetailsIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24265 18.1433C0.61349 14.7474 1.21715 11.2383 2.94499 8.24785C4.67282 5.25737 7.41134 2.98183 10.6677 1.83081V12.7058L1.24265 18.1433Z",
    stroke: "#56736C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5013 15.5634V1C18.0417 1.00038 20.5375 1.6682 22.7386 2.93659C24.9398 4.20498 26.7691 6.02942 28.0433 8.2272C29.3175 10.425 29.9919 12.919 29.999 15.4594C30.0062 17.9998 29.3457 20.4976 28.0838 22.7024C26.8219 24.9073 25.0029 26.742 22.8089 28.0227C20.6149 29.3034 18.1229 29.9852 15.5825 29.9998C13.0421 30.0144 10.5424 29.3613 8.33381 28.1059C6.12521 26.8505 4.28521 25.0369 2.99805 22.8467L15.5013 15.5634Z",
    stroke: "#56736C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDetailsIcon1);
export default __webpack_public_path__ + "static/media/service-details-icon-1.59cae31e9a6681710cec5b93b235d2cd.svg";
export { ForwardRef as ReactComponent };